document.addEventListener("DOMContentLoaded", function () {
  const sliders = document.querySelectorAll(".slider-block input[type='range']");
  const outputBubbles = document.querySelectorAll(".bubble");
  const calcResultElement = document.getElementById("calc-result");
  const calcPotencyElement = document.getElementById("calc-potency");
  const calcTotalActivesElement = document.getElementById("calc-total-actives");

  // Function to update calculation based on slider values
  function updateCalculation() {
    let herbInGrams = 0;
    let percentageOfActives = 0;
    let oilInMl = 0;
    let numberOfDoses = 0;

    sliders.forEach((slider, index) => {
      const value = parseInt(slider.value);
      switch (index) {
        case 0:
          herbInGrams = value;
          break;
        case 1:
          percentageOfActives = value;
          break;
        case 2:
          oilInMl = value;
          break;
        case 3:
          numberOfDoses = value;
          break;
      }
    });

    const totalActives = (herbInGrams * (percentageOfActives / 100)); // Convert to g
    const potency = totalActives * 100 / oilInMl;
    const activesPerDose = (totalActives * 1000) / numberOfDoses;

      document.querySelector('#calc-total-actives').textContent = totalActives.toFixed(2);
      document.querySelector('#calc-potency').textContent = potency.toFixed(1);
      document.querySelector('#calc-result').textContent = activesPerDose.toFixed(0);

  }

  // Event listeners for sliders to update bubble positions and calculations
  sliders.forEach((slider, index) => {
    slider.addEventListener("input", (event) => {
      outputBubbles[index].textContent = event.target.value;
      updateBubblePosition(slider, outputBubbles[index]);
      updateCalculation();
    });
    updateBubblePosition(slider, outputBubbles[index]);
  });

  // Function to update the bubble position
  function updateBubblePosition(slider, bubble) {
    const value = (slider.value - slider.min) / (slider.max - slider.min);
    bubble.style.left = `calc(${value * 100}% - ${value * 28}px)`;
    slider.style.setProperty('--value', `${value * 100}%`);
  }

  // Initial calculation update
  updateCalculation();

});

